import React from "react";
import "./IndustryWeServe.css";

import EducationIcon from "../../assets/Education.png";
import HealthcareIcon from "../../assets/Healthcare.png";
import FinanceIcon from "../../assets/Finance.png";
import SportsIcon from "../../assets/Sports.png";
import TourismIcon from "../../assets/Tourism.png";
import FoodIcon from "../../assets/Food.png";
import AutomotiveIcon from "../../assets/Automotive.png";
import EcommerceIcon from "../../assets/E-Commerce.png";
import EntertainmentIcon from "../../assets/Entertainment.png";
import SocialNetworkingIcon from "../../assets/Social-Networking.png";
import { motion } from "framer-motion";
// List of industries with title and icon
const industries = [
  { title: "Education", icon: EducationIcon },
  { title: "Healthcare", icon: HealthcareIcon },
  { title: "Finance", icon: FinanceIcon },
  { title: "Sports", icon: SportsIcon },
  { title: "Tourism", icon: TourismIcon },
  { title: "Food", icon: FoodIcon },
  { title: "Automotive", icon: AutomotiveIcon },
  { title: "E-Commerce", icon: EcommerceIcon },
  { title: "Entertainment", icon: EntertainmentIcon },
  { title: "Social Networking", icon: SocialNetworkingIcon },
];

const IndustryWeServe = () => {
  return (
    <section className="industry-wrapper">
      <div className="industry-container">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="industry-title">
            Built With Industry <span>Expertise</span>
          </h2>
        </motion.div>

        {/* Section Subtitle */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="industry-subtitle">
            We don’t just follow trends, we understand your industry.
          </p>
        </motion.div>

        {/* Grid Container for Industry Boxes */}
        <div className="industry-grid">
          {industries.map((item, index) => (
            <div className="industry-box" key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                {/* Industry Icon */}
                <img src={item.icon} alt={item.title} />
                {/* Industry Title */}
                <p>{item.title}</p>
            </motion.div>
              </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryWeServe;
